<template>
  <div
    v-if="visible"
    class="act004-quiz-img-opt-overlay"
    :class="{ 'act004-quiz-img-opt-overlay--inline': inlineAnchored }"
  >
    <div class="act004-quiz-img-opt-overlay__stage">
      <div
        v-for="(row, oi) in optionRows"
        :key="'opt-' + oi"
        class="act004-quiz-img-opt-overlay__hit"
        :style="hitStyle(oi)"
        @click="onToggleOption(oi)"
      >
        <img
          v-if="isOptionSelected(oi) && selectedImageUrl(oi)"
          :src="selectedImageUrl(oi)"
          class="act004-quiz-img-opt-overlay__selected-img"
          alt=""
        />
      </div>
      <div
        v-if="nextButtonBox"
        class="act004-quiz-img-opt-overlay__hit"
        :style="nextBtnStyle"
        @click="$emit('submit')"
      />
      <div
        v-else
        class="act004-quiz-img-opt-overlay__submit-fixed"
        @click="$emit('submit')"
      >
        {{ submitting ? '提交中...' : '提交本题' }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  parseImageOptionLayoutConfig,
  imageOptionHotspotStyle,
  normalizeQuizImageUrl
} from '@/utils/activity-multi/quiz-image-option-layout'
import { mergeHotspotDebugStyle } from '@/utils/hotspot-debug'
import { rpxToPx } from '@/utils'

export default {
  name: 'Act004QuizImageOptionOverlay',
  props: {
    visible: { type: Boolean, default: false },
    question: { type: Object, default: null },
    layoutConfig: { type: [Object, String], default: null },
    selectedOptionIds: { type: Array, default: () => [] },
    submitting: { type: Boolean, default: false },
    windowWidthPx: { type: Number, default: 375 },
    inlineAnchored: { type: Boolean, default: false }
  },
  computed: {
    parsedLayout() {
      return parseImageOptionLayoutConfig(this.layoutConfig)
    },
    optionLayoutList() {
      return (this.parsedLayout && this.parsedLayout.options) || []
    },
    nextButtonBox() {
      return this.parsedLayout && this.parsedLayout.nextButton
    },
    nextBtnStyle() {
      return mergeHotspotDebugStyle(imageOptionHotspotStyle(this.nextButtonBox, this.rpxPx))
    },
    optionRows() {
      const layoutOpts = this.optionLayoutList
      const q = this.question
      const qOpts = q && Array.isArray(q.options) ? q.options : []
      const n = layoutOpts.length
      return Array.from({ length: n }, (_, oi) => ({
        optionId: qOpts[oi] && qOpts[oi].optionId != null ? qOpts[oi].optionId : null
      }))
    },
    questionTypeUpper() {
      const t = this.question && this.question.questionType
      return String(t || 'SINGLE').toUpperCase()
    }
  },
  methods: {
    rpxPx(rpx) {
      return rpxToPx(rpx, this.windowWidthPx || 375)
    },
    hitStyle(oi) {
      const box = this.optionLayoutList[oi] || {}
      return mergeHotspotDebugStyle(imageOptionHotspotStyle(box, this.rpxPx))
    },
    selectedImageUrl(oi) {
      const box = this.optionLayoutList[oi]
      return normalizeQuizImageUrl(box && box.selectedImage)
    },
    isOptionSelected(oi) {
      const item = this.optionRows[oi]
      if (!item || item.optionId == null) return false
      return this.selectedOptionIds.some((id) => String(id) === String(item.optionId))
    },
    onToggleOption(oi) {
      const item = this.optionRows[oi]
      if (!item || item.optionId == null) return
      this.$emit('toggle-option', {
        optionId: item.optionId,
        questionType: this.questionTypeUpper
      })
    }
  }
}
</script>

<style scoped>
.act004-quiz-img-opt-overlay {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10050;
  pointer-events: none;
}
.act004-quiz-img-opt-overlay--inline {
  position: absolute;
  z-index: 50;
}
.act004-quiz-img-opt-overlay__stage {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}
.act004-quiz-img-opt-overlay__hit {
  pointer-events: auto;
  cursor: pointer;
  background: transparent;
  -webkit-tap-highlight-color: transparent;
}
.act004-quiz-img-opt-overlay__selected-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  pointer-events: none;
}
.act004-quiz-img-opt-overlay--inline .act004-quiz-img-opt-overlay__submit-fixed {
  position: absolute;
}
.act004-quiz-img-opt-overlay__submit-fixed {
  position: fixed;
  left: 50%;
  bottom: 48px;
  transform: translateX(-50%);
  z-index: 10051;
  pointer-events: auto;
  padding: 12px 32px;
  background: #409eff;
  color: #fff;
  border-radius: 8px;
  font-size: 16px;
}
</style>
